import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import {
  Box,
  Button,
  FormGroupRow,
  HorizontalFormControl,
  SelectCampaign,
  SelectProducts,
  SelectSchemes,
} from '../../../common/components';
import { Col, Row, Form } from 'react-bootstrap';
import {
  CheckboxUnlabeled,
  TextField,
  SelectField,
} from '../../../common/components/ReduxFormField';
import { get } from 'lodash';
import { InternalButtonBar } from '../../layout/components';
import { connect } from 'react-redux';
import AsyncSelectMenu from '../../../common/components/SelectMenu/AsyncSelectMenu';
import getIncludedResource from '../../../helpers/getIncludedResource';
import Loader from '../../../common/components/Loader/Loader';

class ChannelNewForm extends Component {
  render() {
    const { handleSubmit, formValues } = this.props;

    if (!formValues) {
      return <Loader />;
    }
    const broker = getIncludedResource(formValues.data, formValues.included, 'broker');
    return (
      <Box>
        <Form horizontal onSubmit={handleSubmit}>
          <h4 className="page-title">New Channel</h4>
          <Row>
            <Col sm={12}>
              <hr />
            </Col>
            <Col sm={6}>
              <Field
                name="data.attributes.name"
                label="Name"
                labelSize={4}
                component={HorizontalFormControl}
              />
            </Col>
            <Col sm={6}>
              <Field
                name="data.attributes.channel_type"
                fieldSize={8}
                component={SelectField}
                options={channelTypeOptions}
                labelSize={4}
                label="Channel Type"
              />
            </Col>
            <Col sm={6}>
              <Field
                name="data.attributes.key"
                label="Channel Key"
                labelSize={4}
                component={HorizontalFormControl}
              />
            </Col>
            <Col sm={6}>
              <Field
                name="data.attributes.status"
                label={<strong>Enabled?</strong>}
                component={CheckboxUnlabeled}
                inline
                labelSize={4}
                options={[{ label: '', value: true }]}
              />
            </Col>
            <Col sm={6}>
              <Field
                name="data.attributes.whitelabel"
                label={<strong>Is White Label?</strong>}
                component={CheckboxUnlabeled}
                inline
                labelSize={4}
                options={[{ label: '', value: true }]}
              />
            </Col>
            <Col sm={12}>
              <hr />
            </Col>
            <Col sm={6}>
              <FormGroupRow labelSize={4} label="Organisation">
                <Field
                  name="data.relationships.organisation.data.id"
                  optionValuePath={'id'}
                  url={'/organisations?'}
                  component={AsyncSelectMenu}
                  // autoFilters={[
                  //   { type: 'name', exclude: 'International Passenger Protection Limited' },
                  //   { type: 'name', exclude: 'Legal Insurance Management Limited' },
                  // ]}
                  isClearable
                />
              </FormGroupRow>
            </Col>
            <Col sm={6}>
              <Field
                name="data.attributes.metadata.campaign"
                fieldSize={8}
                component={SelectCampaign}
                labelSize={4}
                label="Campaign"
              />
            </Col>
            {!get(formValues, 'data.relationships.organisation.data.id') && (
              <Col sm={6}>
                <FormGroupRow labelSize={4} label="Broker" fieldSize={8}>
                  <Field
                    name="data.relationships.broker.data.id"
                    optionValuePath={'id'}
                    isClearable={true}
                    url={'/brokers?'}
                    component={AsyncSelectMenu}
                    preSelectedOption={broker && broker.data ? broker.data : null}
                  />
                </FormGroupRow>
              </Col>
            )}
            <Col sm={6}>
              <Field
                name="data.relationships.products.data"
                fieldSize={8}
                component={SelectProducts}
                labelSize={4}
                label="Products"
              />
            </Col>
            <Col sm={6}>
              <Field
                name="data.relationships.schemes.data"
                label="Schemes"
                labelFromToDates={true}
                labelSize={4}
                component={SelectSchemes}
              />
            </Col>
            <Col sm={12}>
              <hr />
            </Col>
            <Col sm={6}>
              <Field
                name="data.attributes.metadata.phone"
                label="Phone"
                labelSize={4}
                component={HorizontalFormControl}
              />
            </Col>
            <Col sm={6}>
              <Field
                name="data.attributes.metadata.opening_hours"
                label="Opening Hours"
                labelSize={4}
                component={HorizontalFormControl}
              />
            </Col>
            <Col sm={12}>
              <Field
                name="data.attributes.metadata.footer"
                type="textarea"
                component={TextField}
                labelSize={2}
                label="Footer"
                smFieldSize={10}
                smLableFieldSize={4}
              />
            </Col>
            <Col sm={12}>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <InternalButtonBar
                buttons={[
                  {
                    permissions: ['marketing.source_create'],
                    button: (
                      <Button
                        size="large"
                        type="submit"
                        className="pull-right pad-right"
                        label="Create Channel"
                        bsStyle="primary"
                      />
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        </Form>
      </Box>
    );
  }
}

const channelTypeOptions = [
  { label: 'B2B', value: 'B2B' },
  { label: 'B2C', value: 'B2C' },
  { label: 'B2E', value: 'B2E' },
  { label: 'Call Centre', value: 'DIR' },
  { label: 'Aggregator', value: 'AGG' },
];

const form = reduxForm({
  form: 'ChannelNewForm',
})(ChannelNewForm);

export default connect((state) => ({
  initialValues: {
    data: {
      attributes: {
        name: '',
      },
      relationships: {
        broker: {
          data: '',
        },
        organisation: {
          data: '',
        },
      },
    },
  },
  formValues: getFormValues('ChannelNewForm')(state),
}))(form);
